import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const ErrorMessage = ({ error }) =>
  error ? <span className="error-message">{error}</span> : null;

ErrorMessage.defaultProps = {
  error: '',
};

ErrorMessage.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default ErrorMessage;
